import {createApp} from 'vue'
import App from './App2.vue'
import router from './router'
import {createPinia} from 'pinia'


import {Toast, Cascader, Field, Popup, Picker, Empty, Dialog, Stepper,Loading,Overlay,List,NavBar,Step, Steps,Popover,Uploader,BackTop ,Skeleton,SkeletonTitle,SkeletonImage,SkeletonParagraph} from 'vant';
import "vant/lib/index.css"


const pinia = createPinia()

const app = createApp(App)


app.use(router)
app.use(pinia)
app.use(Toast).use(Cascader).use(Field).use(Popup).use(Picker).use(Empty).use(Dialog).use(Stepper).use(Loading).use(Overlay).use(List).use(NavBar).use(Step).use(Steps).use(Popover).use(Uploader).use(BackTop).use(Skeleton).use(SkeletonTitle).use(SkeletonImage).use(SkeletonParagraph)

app.mount('#app')

